import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getColoredPolygons } from '../../components/polygons_drawer/helpers';
import { MAP_FLAT_TYPE_TO_FLAT_TYPE_FOR_FILTER } from '../../types/mvk_state';
import { sortFlatsByRooms } from '../array/sorters';
import { getMVKHouseById } from '../mvk_data';
import { getFloorScheme, getSectionInHouse } from './sections';
export function getSectionFlats(MVKData, houseId, sectionId) {
  if (!houseId || !sectionId) {
    return [];
  }
  var selectedHouse = getMVKHouseById(MVKData, houseId);
  var selectedSection = selectedHouse && selectedHouse.sections.find(function (section) {
    return section.id === sectionId;
  });
  var flats = selectedSection && MVKData.offers.filter(function (offer) {
    return offer.houseId === houseId && offer.sectionNumber === selectedSection.number;
  });
  return flats || [];
}
export function getFlatsInSectionFloor(MVKData, houseId, sectionId, floor) {
  if (!houseId || !sectionId || !floor) {
    return [];
  }
  var sectionFlats = getSectionFlats(MVKData, houseId, sectionId);
  var floorFlats = sectionFlats.filter(function (flat) {
    return flat.floor === floor;
  });
  var floorScheme = getFloorScheme(MVKData, houseId, sectionId, floor);
  var floorFlatsWithPolygons = floorFlats.filter(function (flat) {
    return floorScheme && floorScheme.floorPlanFlats.some(function (floorPlan) {
      return floorPlan.flatNumber === flat.flatNumber;
    });
  });
  return floorFlatsWithPolygons;
}
export function getFlatTypesInFloor(MVKData, houseId, sectionId, floor) {
  if (!houseId || !sectionId || !floor) {
    return [];
  }
  var flatsInSectionFloor = getFlatsInSectionFloor(MVKData, houseId, sectionId, floor);
  var floorFlatTypes = flatsInSectionFloor.map(function (flat) {
    return flat.roomCount;
  });
  return _toConsumableArray(new Set(floorFlatTypes));
}

// Простейший кэш, т.к. расчет similar offers довольно ресурсоемкий
var SIMILAR_OFFERS_CACHE = {};
export function getSimilarOffers(MVKData, offerId) {
  if (!offerId) {
    return [];
  }
  if (SIMILAR_OFFERS_CACHE[offerId]) {
    return SIMILAR_OFFERS_CACHE[offerId];
  }
  var currentOffer = MVKData.offers.find(function (offer) {
    return offer.id === offerId;
  });
  if (!currentOffer) {
    return [];
  }
  var houseId = currentOffer ? currentOffer.houseId : -1;
  var selectedHouse = getMVKHouseById(MVKData, houseId);
  if (!selectedHouse) {
    return [];
  }
  var offers = getOffersConnectedToMVK(MVKData, selectedHouse.id).filter(function (ofr) {
    if (!currentOffer) {
      return false;
    }
    var offerRoomCount = currentOffer.roomCount;
    return ofr.houseId === houseId && selectedHouse.sections.some(function (section) {
      return section.number === ofr.sectionNumber;
    }) && ofr.roomCount === offerRoomCount && ofr.id !== offerId;
  });
  var offersViewModel = [];
  offers.forEach(function (offer) {
    selectedHouse.sections.forEach(function (section) {
      if (offersViewModel.some(function (offerVm) {
        return offerVm.flatNumber === offer.flatNumber && offerVm.floor === offer.floor;
      })) {
        return;
      }
      var selectedSection = getSectionInHouse(MVKData, houseId, section.id);
      var floorScheme = selectedSection && selectedSection.floorPlans.find(function (floorPlan) {
        return floorPlan.floors.includes(offer.floor);
      });
      if (!floorScheme || offer.sectionNumber !== section.number) {
        return;
      }
      var floorFlats = getFlatsInSectionFloor(MVKData, houseId, section.id, offer.floor);
      offersViewModel.push({
        analyticsData: offer.analyticsData,
        area: offer.area,
        flatNumber: offer.flatNumber,
        floor: offer.floor,
        houseId: offer.houseId,
        id: offer.id,
        polygons: getColoredPolygons(floorScheme.floorPlanFlats, floorFlats, undefined, offer.flatNumber),
        price: offer.price,
        roomCount: offer.roomCount,
        roomsTitle: offer.roomsTitle,
        sectionNumber: offer.sectionNumber
      });
    });
  });
  if (Object.keys(SIMILAR_OFFERS_CACHE).length > 100) {
    SIMILAR_OFFERS_CACHE = {};
  }
  SIMILAR_OFFERS_CACHE[offerId] = offersViewModel;
  return offersViewModel;
}
export function getOfferViewModels(MVKData, houseId, sectionId, filters) {
  var selectedFloor = filters.selectedFloor;
  var selectedSection = getSectionInHouse(MVKData, houseId, sectionId);
  var floorScheme = selectedSection && selectedSection.floorPlans.find(function (floorPlan) {
    return !!selectedFloor && floorPlan.floors.includes(selectedFloor);
  });
  if (!floorScheme) {
    return [];
  }
  var floorFlats = getFlatsBySectionFilters(MVKData, filters, houseId, sectionId);
  var offersViewModel = floorFlats.sort(sortFlatsByRooms).map(function (offer) {
    return {
      analyticsData: offer.analyticsData,
      area: offer.area,
      flatNumber: offer.flatNumber,
      id: offer.id,
      polygons: getColoredPolygons(floorScheme.floorPlanFlats, floorFlats, undefined, offer.flatNumber),
      price: offer.price,
      roomCount: offer.roomCount,
      roomsTitle: offer.roomsTitle
    };
  });
  return offersViewModel.filter(Boolean);
}
export function getFloorRangeForSection(section) {
  var min = 0;
  var max = 0;
  section.floorPlans.forEach(function (floorPlan) {
    var floorPlanMin = Math.min.apply(Math, _toConsumableArray(floorPlan.floors));
    var floorPlanMax = Math.max.apply(Math, _toConsumableArray(floorPlan.floors));
    if (floorPlanMin < min || min === 0) {
      min = floorPlanMin;
    }
    if (floorPlanMax > max) {
      max = floorPlanMax;
    }
  });
  return [min, max];
}
export function getOffersConnectedToMVK(MVKData, houseId) {
  var house = getMVKHouseById(MVKData, houseId);
  if (!house) {
    return [];
  }
  return house.sections.reduce(function (result, section) {
    var _getFloorRangeForSect = getFloorRangeForSection(section),
      _getFloorRangeForSect2 = _slicedToArray(_getFloorRangeForSect, 2),
      min = _getFloorRangeForSect2[0],
      max = _getFloorRangeForSect2[1];
    var sectionFlats = [];
    for (var i = min; i <= max; i++) {
      sectionFlats = [].concat(_toConsumableArray(sectionFlats), _toConsumableArray(getFlatsInSectionFloor(MVKData, houseId, section.id, i)));
    }
    return result.concat(sectionFlats);
  }, []);
}
export function getFlatsBySectionFilters(MVKData, filters, houseId, sectionId) {
  var _filters$selectedFlat = filters.selectedFlatTypes,
    selectedFlatTypes = _filters$selectedFlat === void 0 ? [] : _filters$selectedFlat,
    selectedFloor = filters.selectedFloor;
  var floorFlatTypes = getFlatTypesInFloor(MVKData, houseId, sectionId, selectedFloor);
  var flatTypesForFilter = selectedFlatTypes.filter(function (flatType) {
    return floorFlatTypes.includes(flatType);
  });
  var floorFlats = getFlatsInSectionFloor(MVKData, houseId, sectionId, selectedFloor);
  if (flatTypesForFilter.length) {
    floorFlats = floorFlats.filter(function (floorFlat) {
      return flatTypesForFilter.includes(MAP_FLAT_TYPE_TO_FLAT_TYPE_FOR_FILTER[floorFlat.roomCount]);
    });
  }
  return floorFlats;
}